<div class="profile-container" *ngIf="userInformation">
    <h2>Tus detalles</h2>

    <!-- Sección de Profile -->
    <div class="section">
        <div class="section-header">
            <h3>Perfil</h3>
        </div>
        <div class="field">
            <span class="col-1 label">Alias</span>
            <span class="col-2 value">{{ userInformation.accountAlias }}</span>
            <a class="col-8 justify-content-end edit-link" (click)="editName()">Editar</a>
        </div>
        <div class="field">
            <span class="col-1 label">Nombre</span>
            <span class="col-3 value">{{ userInformation.accountName }}</span>
            <a class="col-7 justify-content-end edit-link" (click)="editName()">Editar</a>
        </div>
        <div class="field">
            <span class="col-5 label">Documento de identidad</span>
            <span class="col-2 justify-content-start value">{{ userInformation.identityNumber }}</span>
            <a class="col-2 justify-content-end edit-link" (click)="editName()">Editar</a>
            <a *ngIf="!userInformation.verifiedIdentity" class="col-1 justify-content-end edit-link" (click)="verificationCI()">Verificar</a>
        </div>
        <div class="field">
            <span class="col-1 label">Celular</span>
            <span class="col-2 value">{{ userInformation.cellphoneExt }}{{ userInformation.cellphone }}</span>
            <a class="col-6 justify-content-end edit-link" (click)="editPassword()">Editar</a>
            <a *ngIf="!userInformation.verifiedCellphone" class="col-1 justify-content-start edit-link" (click)="verificationCell()">Verificar</a>
        </div>
    </div>
    <!-- Sección de Account -->
    <div class="section">
        <div class="section-header">
            <h3>Cuenta</h3>
        </div>
        <div class="field">
            <span class="col-1 label">Email</span>
            <span class="col-2 value">{{ userInformation.accountEmail }}</span>
            <a class="col-6 justify-content-end edit-link" (click)="editEmail()">Editar</a>
            <a *ngIf="!userInformation.verifiedEmail" class="col-1 edit-link" (click)="verificationEmail()">Verificar</a>
        </div>

    </div>
    <!-- Sección de Button -->
    <div class="justify-content-center align-content-center align-items-center align-self-center">
        <a class="logout-link" (click)="logout()">Cerrar sesión</a>
    </div>
</div>

